

export const SUPPORT_EMAIL = 'support@loandepot.com';
export const SUPPORT_EMAIL_MAILTO = 'mailto:support@loandepot.com';

export const CUSTOMER_CARE_EMAIL = 'customercare@loandepot.com';
export const CUSTOMER_CARE_EMAIL_MAILTO = 'mailto:customercare@loandepot.com';

export const LOANDEPOT_URLS = {
  CONTACT_US: 'https://www.loandepot.com/about/contactus',

  TERMS_OF_USE: 'https://www.loandepot.com/termsofuse',

  PRIVACY_POLICY: 'https://www.loandepot.com/privacypolicy',

  PRIVACY_AND_SECURITY: 'https://www.loandepot.com/privacypolicy',

  ACCESSIBILITY: 'https://www.loandepot.com/ada-accessibility-statement',

  STATE_LICENSING: 'https://www.loandepot.com/licensing',

  LIFETIME_GUARANTEE: 'https://www.loandepot.com/lifetime-guarantee',

  COOKIE_POLICY: 'https://www.loandepot.com/cookie-policy',

  DISCLAIMERS: 'https://www.loandepot.com/disclaimers',

  TX_CONSUMER_COMPLAINT_DISCLOSURE:
    'https://assets-us-01.kc-usercontent.com/16d20f65-9af1-00bd-acb4-5c8f22d2e988/e35707f0-159e-4e40-a3c1-b7d4375e6d5c/TX%20Consumer%20Complaint%20Disclosure.pdf',

  IL_COMMUNITY_REINVESTMENT_ACT_NOTICE:
    'https://assets-us-01.kc-usercontent.com/a6ffb754-748e-006e-d2fb-89ac413005fe/bb120a61-2e7c-41c3-830d-ca6171f0278c/IL%20CRA%20Notice.pdf',

  TX_SERVICING_DISCLOSURE:
    'https://assets-us-01.kc-usercontent.com/a6ffb754-748e-006e-d2fb-89ac413005fe/f91e509d-d721-4f65-9d53-31b4aa80daf3/TX%20Servicing%20Disclosure.pdf',

  NY_SERVICING_DISCLOSURE:
    'https://assets-us-01.kc-usercontent.com/a6ffb754-748e-006e-d2fb-89ac413005fe/8d856406-39c4-4185-aa02-34f62c0be83f/NY%20Servicing%20Disclosure.pdf',

  NMLS_CONSUMER_ACCESS: 'https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/174457',

  REPAY_AUTOPAY: 'https://repay.loandepot.com/autopay',

  APP_STORE_IOS: 'https://apps.apple.com/us/app/loandepot-mobile/id1600224229',

  APP_STORE_ANDROID: 'https://play.google.com/store/apps/details?id=com.loandepot.loandepotmobile&pli=1',
} as const;

export const REGULATORY_URLS = {
  TEXAS_SML: 'https://www.sml.texas.gov',

  NY_DFS: 'https://www.dfs.ny.gov',
} as const;

export const LOANDEPOT_NMLS_ID = '174457';

export const LOANDEPOT_MAILING_ADDRESS = 'P.O. Box 251027 Plano, TX 75025';

/** Copyright start year for footer */
export const LOANDEPOT_COPYRIGHT_START_YEAR = 2009;

export const LOANDEPOT_NMLS_TEXT = `NMLS#${LOANDEPOT_NMLS_ID} - NMLS Consumer Access`;

export const PROPERTY_TAXES_ESCROW = {
  address: 'PO Box 9223 Coppell, TX 75019-9278',
  phone: '8333720325',
  phoneDisplay: '833-372-0325',
  fax: '8178260707',
  faxDisplay: '817-826-0707',
  email: 'loandepot.dfw@corelogic.com',
} as const;

export const PROPERTY_TAXES_NON_ESCROW = {
  address: 'PO Box 9023 Coppell, TX 75019-9210',
  phone: '8333720325',
  phoneDisplay: '833-372-0325',
  fax: '8178261258',
  faxDisplay: '817-826-1258',
  email: 'paymentproof.dfw.tx@corelogic.com',
} as const;

export const HOMEOWNERS_INSURANCE = {
  location1: 'ISAOA / ATIMA',
  location2: 'P.O. Box 7114 Troy, MI 48007-7114',
  phone: '8774772089',
  phoneDisplay: '877-477-2089',
  fax: '2487101660',
  faxDisplay: '248-710-1660',
  website: 'ExpressInsuranceinfo.com',
  websiteUrl: 'https://www.ExpressInsuranceinfo.com',
  websiteCode: '2917832',
} as const;

export const INSURANCE_CLAIMS = {
  location1: 'loanDepot LLC, Attn: Loss Draft Department',
  location2: 'PO Box 5099, Troy, MI 48007-5099',
  phone: '8888845322',
  phoneDisplay: '888-884-5322',
  fax: '2487101635',
  faxDisplay: '248-710-1635',
  claimProcedurePacketUrl: '/assets/docs/Claim Procedure Packet 82922.docx',
} as const;

export const PAYOFF_STATEMENTS = {
  fax: '4698254845',
  faxDisplay: '469-825-4845',
  email: 'payoffs@loandepot.com',
} as const;

export const HOMEOWNER_SUPPORT_URL = 'https://www.loandepot.com/about/loan-servicing/support-resources';

export const HUD_COUNSELING = {
  phone: '18005694287',
  phoneDisplay: '800-569-4287',
} as const;

export const WA_HOMEOWNERSHIP_HOTLINE = {
  phone: '18778944663',
  phoneDisplay: '1-877-894-HOME (1-877-894-4663)',
} as const;
